import { Mountain, Phone, Mail, MapPin, Lock } from "lucide-react";
import { useAdminAuth } from "@/context/AdminAuth";

export const Footer = () => {
  const { openModal } = useAdminAuth();
  return (
    <footer data-testid="site-footer" className="relative overflow-hidden bg-[#0d2116] text-white">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 sm:px-6 md:grid-cols-3 lg:px-8">
        <div>
          <div className="flex items-center gap-2.5">
            <img src="/data-earth-logo.webp" alt="Data Earth Surveying" className="h-10 w-10 object-contain" />
            <span className="font-display text-lg font-bold">Data Earth Surveying</span>
          </div>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-white/60">
            Licensed land and construction surveying across The Bahamas. Precise layouts,
            control points, and elevation checks you can build on.
          </p>
        </div>
        <div>
          <h4 className="font-display text-sm font-semibold uppercase tracking-wider text-[#c8a452]">Services</h4>
          <ul className="mt-4 space-y-2 text-sm text-white/70">
            <li>Building Corners & Footing Layout</li>
            <li>Structural & Control Points</li>
            <li>Elevation & Boundary Reference</li>
            <li>Road & Utility Alignment</li>
          </ul>
        </div>
        <div>
          <h4 className="font-display text-sm font-semibold uppercase tracking-wider text-[#c8a452]">Contact</h4>
          <ul className="mt-4 space-y-3 text-sm text-white/70">
            <li className="flex items-center gap-2"><Phone className="h-4 w-4 text-[#c8a452]" /> <a href="tel:+12428226000" className="transition-colors hover:text-white">1 (242) 822-6000</a></li>
            <li className="flex items-center gap-2"><Mail className="h-4 w-4 text-[#c8a452]" /> <a href="mailto:dataearthsurveying@gmail.com" className="transition-colors hover:text-white">dataearthsurveying@gmail.com</a></li>
            <li className="flex items-center gap-2"><MapPin className="h-4 w-4 text-[#c8a452]" /> Nassau, The Bahamas</li>
            <li>
              <button onClick={openModal} data-testid="footer-admin-link"
                className="inline-flex items-center gap-2 text-[#c8a452] transition-colors hover:text-white">
                <Lock className="h-3.5 w-3.5" /> Admin Portal
              </button>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-xs text-white/40">
        © {new Date().getFullYear()} Data Earth Surveying. All rights reserved.
      </div>
    </footer>
  );
};
